import { render, staticRenderFns } from "./AdsCategories.vue?vue&type=template&id=2ea7f0bf&scoped=true&"
import script from "./AdsCategories.vue?vue&type=script&lang=js&"
export * from "./AdsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7f0bf",
  null
  
)

export default component.exports